import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './assets/css/App.css';
import 'leaflet/dist/leaflet.css';

import App from './App';
import ErrorBoundary from './components/error/ErrorBoundary';
import { initMarketingTracking } from './marketing/tracking';

// The webpack dev overlay is removed via MutationObserver in public/index.html.
// Do NOT suppress window.onerror here — it hides chunk-load failures and leaves
// users with a blank page (NO_FCP) when a bundle fails to load.

// Serve the Super-Admin Ops Console instead of the tenant app when on the
// `ops.*` subdomain (production) or when REACT_APP_PORTAL=ops (local :3013).
// Lazy-loaded so the ops code is a SEPARATE chunk tenant users never download.
const isOpsPortal =
  process.env.REACT_APP_PORTAL === 'ops' ||
  (typeof window !== 'undefined' &&
    window.location.hostname.split('.')[0] === 'ops');

const OpsRoot = React.lazy(() => import('./ops/OpsRoot'));

// Load marketing analytics (GTM) ONLY on the public marketing site — never on
// the Ops Console or a tenant portal. initMarketingTracking() self-gates via
// isMarketingSite(); the extra !isOpsPortal check keeps the intent explicit.
if (!isOpsPortal) {
  initMarketingTracking();
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    {isOpsPortal ? (
      <React.Suspense fallback={null}>
        <OpsRoot />
      </React.Suspense>
    ) : (
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    )}
  </ErrorBoundary>,
);
